import { KeyboardBackspace, SettingsOutlined } from "@mui/icons-material";
import { Avatar, CardContent, Divider, Grid2, IconButton, Menu, MenuItem, Stack, Typography } from "@mui/material";
import SurfaceCard from "@components/shared/ui/SurfaceCard";
import { stringAvatar } from "../../../../utils/helper";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../../../context/AuthContext";
import { useGetMyChildrenLookup } from "@services/parent/students";

export default function ParentProfile() {
  const { profile: user } = useAuth();
  const { rows: children, loading: childrenLoading } = useGetMyChildrenLookup();
  
  return (
    <Stack alignItems="start" spacing={2}>
      <Grid2 py={1.5} container width="100%" alignItems="center" justifyContent='space-between'>
        <Grid2 container alignItems="center">
          <IconButton color="inherit" component={Link} to={`/${user?.base_role}`}>
            <KeyboardBackspace />
          </IconButton>
          <Typography variant="h6" fontWeight={700}>My Profile</Typography>
        </Grid2>
        
        
        <PopupState variant="popover" popupId="popup-menu">
          {(popupState) => (
            <React.Fragment>
              <IconButton {...bindTrigger(popupState)}>
                <SettingsOutlined fontSize="large" />
              </IconButton>
              <Menu {...bindMenu(popupState)}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
              >
                <MenuItem 
                  component={Link}
                  to="/parent/profile/edit"
                  onClick={popupState.close}
                >
                  Edit Profile
                </MenuItem>
                <MenuItem 
                  component={Link}
                  to="/parent/profile/change-password"
                  onClick={popupState.close}
                >
                  Change Password
                </MenuItem>
              </Menu>
            </React.Fragment>
          )}
        </PopupState>
      </Grid2>
      
      {/* PROFILE */}
      <SurfaceCard sx={{ mt: 4, p: 4, overflow: "visible", alignSelf: "stretch" }}>
        <Stack>
          <Grid2
            container
            sx={{ alignItems: "center", flexWrap: "nowrap" }}
            spacing={2}
          >
            <Avatar
              src={user?.avatar_url ?? undefined}
              {...stringAvatar(`${user?.first_name} ${user?.last_name}`)}
              sx={{ width: "3.2rem", height: "auto", aspectRatio: 1 }}
            />
            <Grid2>
              <Typography variant="title">
                {`${user?.first_name} ${user?.last_name}`}
              </Typography>
            </Grid2>
          </Grid2>
          
          <Grid2 container spacing={2} columnSpacing={4} sx={{ mt: 2 }}>
            <Info label="Email ID" val={user?.email} />
            <Info label="ID Number" val={user?.details?.id_number}/>
            <Info label="Role" val={user?.base_role} capitalized/>
            <Info label="Status" val='Active' />
          </Grid2>
        </Stack>
      </SurfaceCard>

      {/* CHILDREN */}
      <SurfaceCard sx={{ overflow: "visible", alignSelf: "stretch" }}>
        <CardContent sx={{ px: 4, py: 2 }}>
          <Typography variant="header">Children</Typography>
        </CardContent>
        <Divider/>
        <CardContent sx={{ px: 4, py: 2 }}>
          <Grid2 container spacing={1} wrap="wrap">
            {children.map((child) => (
              <SurfaceCard key={child.id} sx={{ px: 1.5, py: 1 }}>
                <Grid2 container spacing={1}>
                  <Avatar {...stringAvatar(`${child.first_name ?? ""} ${child.last_name ?? ""}`)}/>
                  <Stack justifyContent="center">
                    <Typography variant="body1" fontWeight="bold" lineHeight="110%">{`${child.first_name ?? ""} ${child.last_name ?? ""}`.trim()}</Typography>
                    <Typography variant="caption" lineHeight="110%">{child.grade_level ?? ""}</Typography>
                  </Stack>
                </Grid2>
              </SurfaceCard>
            ))}

            {!childrenLoading && children.length === 0 && <Typography>No record found.</Typography>}


          </Grid2>
        </CardContent>
      </SurfaceCard>
      
      
    </Stack>
  );
}

const Info = ({ label, val, capitalized = false }: { label: string; val?: string, capitalized?: boolean }) => (
  <Grid2 size={{ xs: 12, md: 6, lg: 4 }}>
    <Grid2 container alignItems="baseline" spacing={1} wrap="nowrap">
      <Typography variant="weak" whiteSpace="nowrap">{label}:</Typography>
      <Typography variant="subtitle2" className="truncate" textTransform={capitalized ? 'capitalize' : undefined}>{val || "-"}</Typography>
    </Grid2>
  </Grid2>
);
